import { HomeFilterProvider } from '../components/HomeFilterContext';
import { HomeFilterBar } from '../components/HomeFilterBar';
import { WidgetGrid } from '../components/widgets';

export default function HomePage() {
  return (
    <HomeFilterProvider>
      <div className="pb-32">
        <HomeFilterBar />
        <WidgetGrid />
      </div>
    </HomeFilterProvider>
  );
}
